import { useAccount, useDisconnect, useSignMessage } from 'wagmi';

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { trackClairtyEvent } from '../../utils';
import { useBackendApi } from '../backendHelper';

export const useLoginHelper = () => {
  const history = useNavigate();
  const [{ user, setUser, logout }] = useGlobalState();
  const { address, isConnected } = useAccount();
  const { signMessageAsync } = useSignMessage();
  const { disconnect } = useDisconnect();
  const [signingIn, setSigningIn] = useState();
  const backendApi = useBackendApi();

  // will throw on exception
  const userLogin = async () => {
    await walletLogin();
  };

  const walletLogin = async () => {
    try {
      if (signingIn) return;
      if (isConnected && !user) {
        setSigningIn(true);
        const message = 'Login to Mercle';
        const sign = await signMessageAsync({ message });
        const _user = await backendApi.login({
          address: address,
          sign,
        });
        setUser(_user.data);
        trackClairtyEvent('login', address);
        setSigningIn(false);
        return _user.data;
      }
      return user;
    } catch (error) {
      alert.error('Could not login in');
    } finally {
      setSigningIn(false);
    }
  };

  const userLogout = () => {
    disconnect();
    logout();
    backendApi.logout().catch(e => console.error(e));
    history('/');
  };

  const postProcessUserLogin = async user => {
    if (!user) return false;
    setUser(user);
    return true;
  };

  return { userLogin, userLogout, postProcessUserLogin };
};
